import { useEffect } from "react";
import { CardRouded, ContainerV2, H1, Input, P } from "../../Atoms";

import { FormDispatcherCustomerRegisterV2 } from "../../Molecules/FormDispatcherCustomerRegisterV2";
import { useDispatcherCustomerRegisterV2 } from "./useDispatcherCustomerRegisterV2 ";
import { Tracking } from "../../../services/Tracking";

export const DispatcherCustomerRegisterV2 = () => {
  const { handleRegister, step, clientForm, setStep, handleConfirm } =
    useDispatcherCustomerRegisterV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/cadastro-cliente:pageview");
  });

  const currentPage = () => {
    if (step === 1) {
      return (
        <ContainerV2
          nextButton={{ title: "Cadastrar", form: "client-register" }}
        >
          <H1>Cadastrar novo cliente</H1>
          <P className="mb-8">
            Preencha os dados para criar o cadastro do cliente.
          </P>

          <CardRouded className="w-full mx-auto">
            <FormDispatcherCustomerRegisterV2
              id="client-register"
              onSubmitForm={handleRegister}
              defaultValue={clientForm || undefined}
            />
          </CardRouded>
        </ContainerV2>
      );
    }
    return (
      <ContainerV2
        backButton={{ onClick: () => setStep(1) }}
        nextButton={{ title: "Confirmar", onClick: handleConfirm }}
      >
        <H1 className="mb-4">Confirmar cadastro novo cliente</H1>
        <P className="mb-8">Confirme os dados do novo cliente cadastrado.</P>

        <CardRouded>
          <div className="grid grid-cols-2 gap-6">
            <div className="col-span-2">
              <Input disabled label="Nome" value={clientForm?.nome || ""} />
            </div>

            <Input
              disabled
              label="CPF/CNPJ"
              value={clientForm?.cpfCnpj || ""}
            />
            <Input
              disabled
              label="Telefone"
              value={clientForm?.telefone || ""}
            />
            <div className="col-span-2">
              <Input disabled label="E-mail" value={clientForm?.email || ""} />
            </div>
          </div>
        </CardRouded>
      </ContainerV2>
    );
  };

  return currentPage();
};
